import { render, staticRenderFns } from "./CreateLevelOrEdit.vue?vue&type=template&id=c7b889da&scoped=true&"
import script from "./CreateLevelOrEdit.vue?vue&type=script&lang=js&"
export * from "./CreateLevelOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./CreateLevelOrEdit.vue?vue&type=style&index=0&id=c7b889da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b889da",
  null
  
)

export default component.exports